module.exports = __webpack_public_path__ + "img/seaPalace-1.ca7ea17e.jpg";